import { arrayMaxValidator as ArrayMax } from './ArrayMax';
import { arrayMinValidator as ArrayMin } from './ArrayMin';
import { arrayUniqueValidator as ArrayUnique } from './ArrayUnique';
import { greaterThanValidator as GreaterThan } from './GreaterThan';
import { inValidator as In } from './In';
import { includesValidator as Includes } from './Includes';
import { lessThanValidator as LessThan } from './LessThan';
import { maxValidator as Max } from './Max';
import { minValidator as Min } from './Min';
import { requiredValidator as Required } from './Required';
import { requiredIfValidator as RequiredIf } from './RequiredIf';

export const Validators = {
  ArrayMax,
  ArrayMin,
  ArrayUnique,
  In,
  Includes,
  GreaterThan,
  LessThan,
  Max,
  Min,
  Required,
  RequiredIf,
} as const;
